import { assetTranscoded as assetTranscodedSubscription } from '../subscriptions';

export default async function subscribeToAssetTranscoded(
apiClient,
{ assetId, onSubscriptionData })
{
  const subscriptionParams = {
    query: assetTranscodedSubscription,
    variables: {
      assetId
    },
    fetchPolicy: 'no-cache'
  };

  return apiClient
  // returns an observable we can subscribe to
  .subscribe(subscriptionParams)

  // subscribe to the observer and swallow errors
  .subscribe({ next: onSubscriptionData, error: Function.prototype });
}